var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{class:['footer-gradient', {'desktop': !_vm.isMobile}],style:(`background-size: ${_vm.percent}% 100%`),attrs:{"fixed":"","height":"74","color":"white"}},[_c('div',{staticClass:"percentage"},[_vm._v(" "+_vm._s(_vm.percent)+"% ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }